import React, { useState, useEffect } from 'react'
import { Modal, Input, InputNumber, Select, Row, Col, Alert, message } from 'antd'

import { PAYMENT_REGISTER, requestToServer } from '../lib/helper'
import { paymetMethod } from '../config'
import { todayLima, addMonths, fmtDay } from '../lib/billing'

// Task007: registrar el pago de un clon. `clone` trae los datos de cobro (plan, período, monto, vencimiento, método).
// El nuevo vencimiento sale de sumar los períodos al vencimiento anterior (D4) y se puede corregir a mano.
export default function PaymentModal({ open, clone, prices, onClose, onDone }) {

  const [f, setF] = useState({})
  const [nextTouched, setNextTouched] = useState(false)   // si el operador escribió el vencimiento, ya no se recalcula
  const [saving, setSaving] = useState(false)

  const set = (key) => (value) => setF( prev => ({ ...prev, [key]: value }) )

  // cada vez que se abre: valores precargados desde el clon y, si no hay monto, desde la lista de precios
  useEffect(() => {
    if ( !open || !clone ) { return }
    const list = prices && clone.plan ? prices[clone.plan] : null
    const suggested = list && clone.billingPeriod ? list[clone.billingPeriod] : null
    setF({
      amount: clone.amount !== null && clone.amount !== undefined ? clone.amount : suggested,
      currency: clone.currency || 'USD',
      method: clone.paymentType || undefined,
      paidAt: todayLima(),
      periodsCovered: 1,
      nextDueDate: '',
      reference: '', invoiceNumber: '', note: ''
    })
    setNextTouched(false)
  }, [open, clone && clone.platformName])

  if ( !clone ) { return null }

  const months = ( clone.billingPeriod === 'annual' ? 12 : 1 ) * ( f.periodsCovered || 1 )
  // sin período en el clon no se puede calcular: hay que escribir el vencimiento
  const computed = clone.billingPeriod && ( clone.nextDueDate || f.paidAt ) ? addMonths( clone.nextDueDate || f.paidAt, months ) : ''
  const nextDue = nextTouched ? f.nextDueDate : computed

  const submit = () => {
    setSaving(true)
    requestToServer({ platformName: clone.platformName, ...f, nextDueDate: nextDue || null }, PAYMENT_REGISTER)
      .then( r => { message.success('Pago registrado'); onDone(r) } )
      .catch( () => {} )    // el mensaje (de validación o genérico) ya lo mostró requestToServer
      .finally( () => setSaving(false) )
  }

  return (
    <Modal
      open={open}
      title={'Registrar pago · ' + clone.platformName}
      okText='Registrar'
      cancelText='Cancelar'
      confirmLoading={saving}
      okButtonProps={{ disabled: !f.amount || !f.method || !nextDue || !clone.billingPeriod }}   // Revisión 4: sin período no se registra
      onOk={submit}
      onCancel={onClose}
    >
      <Row gutter={[12, 12]}>
        <Col span={12}>
          Monto<br/>
          <InputNumber style={{ width: '100%' }} min={0} precision={2} value={f.amount} onChange={set('amount')} />
        </Col>
        <Col span={12}>
          Moneda<br/>
          <Input value={f.currency} maxLength={3} onChange={e => set('currency')(e.target.value.toUpperCase())} />
        </Col>
        <Col span={24}>
          Método<br/>
          <Select style={{ width: '100%' }} placeholder='Método de pago' value={f.method} onChange={set('method')}
            options={Object.keys(paymetMethod).map( k => ({ value: k, label: paymetMethod[k] }) )} />
        </Col>
        <Col span={12}>
          Fecha de pago<br/>
          <Input type='date' value={f.paidAt} onChange={e => set('paidAt')(e.target.value)} />
        </Col>
        <Col span={12}>
          Períodos cubiertos<br/>
          <InputNumber style={{ width: '100%' }} min={1} max={24} precision={0} value={f.periodsCovered} onChange={set('periodsCovered')} />
        </Col>
        <Col span={24}>
          Próximo vencimiento{ !nextTouched && computed && <span style={{ color: '#888' }}> (calculado: {fmtDay(computed)})</span> }<br/>
          <Input type='date' value={nextDue} onChange={e => { setNextTouched(true); set('nextDueDate')(e.target.value) }} />
        </Col>
        <Col span={12}>
          Referencia (transacción / link)<br/>
          <Input value={f.reference} onChange={e => set('reference')(e.target.value)} />
        </Col>
        <Col span={12}>
          N.º de comprobante<br/>
          <Input value={f.invoiceNumber} onChange={e => set('invoiceNumber')(e.target.value)} />
        </Col>
        <Col span={24}>
          Nota<br/>
          <Input.TextArea autoSize={{ minRows: 2 }} value={f.note} onChange={e => set('note')(e.target.value)} />
        </Col>
      </Row>

      {/* Revisión 4: el backend también lo rechaza; acá se avisa antes de llenar todo el formulario */}
      { !clone.billingPeriod &&
        <Alert type='warning' showIcon style={{ marginTop: 12 }}
          message='El clon no tiene período (mensual / anual). Cárgalo en su ficha y guarda el cobro antes de registrar el pago.' /> }
      { nextDue && nextDue < todayLima() &&
        <Alert type='warning' showIcon style={{ marginTop: 12 }}
          message='Con esa fecha el clon seguirá vencido. Si pagó varios períodos, súbelos arriba.' /> }
      { clone.billingState === 'suspended' &&
        <Alert type='info' showIcon style={{ marginTop: 12 }}
          message='El clon está suspendido: el pago reactiva el cobro, pero hay que levantarlo aparte (botón Levantar en su ficha).' /> }
    </Modal>
  )
}
